import { IDataSubscription } from './data.types'
import ws from '../ws'
import { IEquipment } from '@/pages/Equipment/equipment.types.ts'
import { IParameter } from '@/pages/Parameters/parameters.types.ts'
import debounceDecorator from '@/utils/debounce/debounce.decorator.ts'
import { TDeviceProtocol } from '@/services/ws/ws.types.ts'

class DataSubscriptionManager {
  subscriptions: Array<IDataSubscription> = []

  constructor() {}

  public addSubscription = (sub: IDataSubscription) => {
    this.subscriptions.push(sub)
    this.updateWSSubscription()
  }

  public removeSubscription = (id: IDataSubscription['id']) => {
    const subscriptionIndex = this.subscriptions.findIndex((s) => s.id === id)
    if (subscriptionIndex === -1) return

    this.subscriptions.splice(subscriptionIndex, 1)
    this.updateWSSubscription()
  }

  @debounceDecorator(300)
  private updateWSSubscription() {
    const devicesMap = new Map<IEquipment['id'], TDeviceProtocol>()
    const parametersSet = new Set<IParameter['id']>()
    const sourceIdsSet = new Set<IParameter['sourceId']>()

    for (const sub of this.subscriptions) {
      for (let i = 0; i < sub.devices.length; ++i) {
        const deviceId = sub.devices[i]
        const deviceProtocol = sub.deviceProtocols[i] ?? 'lp-lift'

        devicesMap.set(deviceId, deviceProtocol)
      }
      for (const parameter of sub.parameters) parametersSet.add(parameter)
      for (const parameter of sub.parametersSourceIds) sourceIdsSet.add(parameter)
    }

    const devices = Array.from(devicesMap.keys())

    ws.dataSubscribe({
      version: 'v1',
      data: {
        devices,
        deviceProtocols: devices.map((deviceId) => devicesMap.get(deviceId) ?? 'lp-lift'),
        parameters: Array.from(parametersSet),
        parametersSourceIds: Array.from(sourceIdsSet),
      },
    })
  }
}

const dataSubscriptionManager = new DataSubscriptionManager()
export default dataSubscriptionManager
